import { css } from '@emotion/react';

const styles = css`
  img {
    width: 128px;
    height: 65px;
    object-fit: cover;
    object-position: center;
  }
`;

export default styles;
